import { render, staticRenderFns } from "./tariffManagement.vue?vue&type=template&id=7522270a&scoped=true&"
import script from "./tariffManagement.vue?vue&type=script&lang=js&"
export * from "./tariffManagement.vue?vue&type=script&lang=js&"
import style0 from "./tariffManagement.vue?vue&type=style&index=0&id=7522270a&lang=scss&scoped=true&"
import style1 from "./tariffManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522270a",
  null
  
)

export default component.exports